import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProjectContextService {
  private readonly storageKey = 'tb.projectId';
  private readonly projectIdSubject = new BehaviorSubject<string | null>(this.readFromStorage());

  readonly projectId$ = this.projectIdSubject.asObservable();

  get projectId() {
    return this.projectIdSubject.value;
  }

  setProjectId(projectId: string | null) {
    const normalized = projectId?.trim() ? projectId.trim() : null;
    this.projectIdSubject.next(normalized);

    if (typeof window === 'undefined') return;

    if (normalized) {
      window.localStorage.setItem(this.storageKey, normalized);
    } else {
      window.localStorage.removeItem(this.storageKey);
    }
  }

  private readFromStorage(): string | null {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(this.storageKey);
  }
}

